import ListPage from './ListPage';

export default ListPage;
